import React from 'react'
import { Heading } from 'theme-ui'
import Divider from '@components/Divider'

/**
 * Shadow me to add your own content
 */

const styles = {
  heading: {
    background: (t) => `
      linear-gradient(
        45deg,
        ${t.colors.alpha} 32.5%,
        ${t.colors.betaDark} 50.5%)
    `,
    color: `beta`,
    WebkitBackgroundClip: `text`,
    WebkitTextFillColor: `transparent`,
    fontWeight: `bold`,
  },
  running: {
    color: `omegaDark`,
    fontWeight: `normal`,
    maxWidth: [`full`, `full`, `2/3`],
  },
}

export default () => (
  <>
    <Divider space={3} />
    <Heading variant='h1' sx={styles.heading}>
      Analyze Golf Videos
      <br />
      while you sleep.
    </Heading>
    <Divider space={3} />
    <Heading variant='h3' sx={styles.running}>
      Create more revenue streams, and generate more leads for in-person instruction quickly and easily. Technology is changing faster than ever, and golf instruction is changing with it.
    </Heading>
  </>
)
